import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, vModelRadio as _vModelRadio } from "vue";
const _hoisted_1 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_4 = {
  class: "space-y-6"
};
const _hoisted_5 = {
  class: "bg-white rounded-xl border border-slate-200 p-6"
};
const _hoisted_6 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_7 = {
  class: "col-span-2"
};
const _hoisted_8 = {
  class: "col-span-2"
};
const _hoisted_9 = {
  key: 0,
  class: "col-span-2"
};
const _hoisted_10 = {
  key: 1,
  class: "col-span-2"
};
const _hoisted_11 = {
  class: "col-span-2"
};
const _hoisted_12 = {
  class: "bg-white rounded-xl border border-slate-200 p-6"
};
const _hoisted_13 = {
  class: "mb-4 p-4 bg-slate-50 border border-slate-200 rounded-lg"
};
const _hoisted_14 = {
  class: "flex items-center gap-4"
};
const _hoisted_15 = {
  class: "flex items-center gap-2"
};
const _hoisted_16 = {
  class: "mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg"
};
const _hoisted_17 = {
  class: "flex items-center gap-2 text-sm text-blue-700"
};
const _hoisted_18 = {
  key: 0,
  class: "text-center py-8 text-slate-500"
};
const _hoisted_19 = {
  class: "space-y-2"
};
const _hoisted_20 = {
  class: "flex items-center gap-3"
};
const _hoisted_21 = {
  class: "flex items-center justify-center w-6 h-6 bg-slate-100 rounded-full"
};
const _hoisted_22 = {
  class: "text-xs font-medium text-slate-600"
};
const _hoisted_23 = {
  class: "flex-1 grid grid-cols-5 gap-4"
};
const _hoisted_24 = {
  class: "font-medium text-slate-900"
};
const _hoisted_25 = {
  class: "text-sm text-slate-700"
};
const _hoisted_26 = {
  class: "text-sm text-slate-700"
};
const _hoisted_27 = {
  class: "text-sm text-slate-700"
};
const _hoisted_28 = {
  key: 0,
  class: "text-xs text-slate-400 mt-1"
};
const _hoisted_29 = {
  class: "flex items-center gap-1"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_33 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_34 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_35 = {
  class: "p-6 overflow-y-auto max-h-[calc(90vh-140px)]"
};
const _hoisted_36 = {
  class: "space-y-6"
};
const _hoisted_37 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_38 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_39 = {
  class: "bg-slate-50 rounded-lg p-4"
};
const _hoisted_40 = {
  class: "mb-4"
};
const _hoisted_41 = {
  class: "grid grid-cols-5 gap-2"
};
const _hoisted_42 = ["value"];
const _hoisted_43 = {
  class: "text-sm text-slate-700"
};
const _hoisted_44 = {
  key: 0,
  class: "space-y-4"
};
const _hoisted_45 = {
  class: "flex items-center gap-2"
};
const _hoisted_46 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_47 = {
  class: "flex items-center gap-2"
};
const _hoisted_48 = {
  class: "flex items-center gap-2"
};
const _hoisted_49 = {
  key: 1
};
const _hoisted_50 = {
  class: "flex items-center gap-2"
};
const _hoisted_51 = {
  key: 2,
  class: "space-y-3"
};
const _hoisted_52 = {
  class: "flex-1"
};
const _hoisted_53 = ["onUpdate:modelValue"];
const _hoisted_54 = {
  class: "flex-1"
};
const _hoisted_55 = ["onUpdate:modelValue"];
const _hoisted_56 = ["onClick"];
const _hoisted_57 = {
  key: 3
};
const _hoisted_58 = {
  class: "flex items-center gap-2"
};
const _hoisted_59 = {
  key: 4,
  class: "p-4 bg-green-50 border border-green-200 rounded-lg text-sm text-green-700"
};
const _hoisted_60 = {
  key: 5
};
const _hoisted_61 = {
  class: "flex items-center gap-2"
};
const _hoisted_62 = {
  class: "mt-4 pt-4 border-t border-slate-200"
};
import { ref, reactive, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import FranchiseePicker from '@/components/FranchiseeSelector/FranchiseePicker.vue';
import ProductPicker from './components/ProductSelector/ProductPicker.vue';
import AppModal from '@/components/AppModal.vue';
import { getCommissionRule, createCommissionRule, updateCommissionRule } from '@/api/commission';
export default {
  __name: 'CommissionRuleForm',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editId: {
      type: [String, Number],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const isEdit = computed(() => !!props.editId);

    // 规则类型
    const ruleTypes = [{
      value: 'GLOBAL',
      label: '全局规则'
    }, {
      value: 'FRANCHISEE',
      label: '加盟商规则'
    }, {
      value: 'PRODUCT',
      label: '产品规则'
    }];
    const taxReceiverOptions = [{
      value: 'PLATFORM',
      label: '平台代收'
    }, {
      value: 'FRANCHISEE',
      label: '加盟商代收'
    }];

    // 角色编码选项
    const roleOptions = [{
      value: 'REFERRER',
      label: '引入人'
    }, {
      value: 'FRANCHISEE',
      label: '加盟商'
    }, {
      value: 'PLATFORM',
      label: '平台'
    }];

    // 计算类型
    const calculateTypes = [{
      value: 'RATIO',
      label: '固定比例'
    }, {
      value: 'FIXED',
      label: '固定金额'
    }, {
      value: 'LADDER',
      label: '阶梯分成'
    }, {
      value: 'MINIMUM',
      label: '最低分成'
    }, {
      value: 'REMAINDER',
      label: '剩余分配'
    }, {
      value: 'RELATIVE_REMAINDER',
      label: '相对剩余比例'
    }];

    // 表单数据
    const form = reactive({
      ruleName: '',
      ruleType: 'GLOBAL',
      productId: null,
      franchiseeId: null,
      priority: 0,
      status: 0,
      referrerTaxReceiverRole: 'PLATFORM',
      remark: '',
      roleConfigs: []
    });

    // 角色表单
    const roleForm = reactive({
      roleCode: '',
      roleName: '',
      calculateType: 'RATIO',
      value: 0,
      minAmount: null,
      maxAmount: null,
      ladderSteps: [],
      priority: 0
    });

    // 弹窗状态
    const showRoleForm = ref(false);
    const isEditingRole = ref(false);
    const editingRoleIndex = ref(-1);

    // 计算基准金额
    const calculationAmount = ref(10000);

    // 格式化金额显示
    const formatAmount = amount => {
      return (amount || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    };

    // 保留两位小数（更建议用“分”为单位做整数运算，这里先最小改动）
    const round2 = n => Math.round((n + Number.EPSILON) * 100) / 100;

    /**
     * @param role 角色配置
     * @param currentRemaining 当前剩余金额
     * @param base 原始基准金额（calculationAmount）
     */
    const calculateSingleRole = (role, currentRemaining, base) => {
      let amount = 0;
      let remaining = currentRemaining;
      switch (role.calculateType) {
        case 'RATIO':
          {
            // 固定比例：按 base 计算
            amount = (base || 0) * (role.value || 0) / 100;

            // min/max 约束（注意 0 也要生效，所以用 != null）
            if (role.minAmount != null && amount < role.minAmount) amount = role.minAmount;
            if (role.maxAmount != null && amount > role.maxAmount) amount = role.maxAmount;

            // 不能超过剩余
            amount = Math.min(amount, currentRemaining);
            remaining = currentRemaining - amount;
            break;
          }
        case 'FIXED':
          {
            amount = Math.min(role.value || 0, currentRemaining);
            remaining = currentRemaining - amount;
            break;
          }
        case 'LADDER':
          {
            // 阶梯分成：按 base 计算，根据 base 匹配阶梯
            const steps = Array.isArray(role.ladderSteps) ? role.ladderSteps : [];
            const sortedSteps = [...steps].sort((a, b) => (b.threshold || 0) - (a.threshold || 0));
            const matched = sortedSteps.find(s => base >= (s.threshold || 0));
            amount = base * (matched?.ratio || 0) / 100;
            amount = Math.min(amount, currentRemaining);
            remaining = currentRemaining - amount;
            break;
          }
        case 'MINIMUM':
          {
            // 最低分成：保底固定金额
            amount = Math.min(role.value || 0, currentRemaining);
            remaining = currentRemaining - amount;
            break;
          }
        case 'REMAINDER':
          {
            amount = currentRemaining;
            remaining = 0;
            break;
          }
        case 'RELATIVE_REMAINDER':
          {
            amount = currentRemaining * (role.value || 0) / 100;
            amount = Math.min(amount, currentRemaining);
            remaining = currentRemaining - amount;
            break;
          }
        default:
          amount = 0;
          remaining = currentRemaining;
      }
      return {
        amount: round2(amount),
        remaining: round2(remaining)
      };
    };

    // 计算单个角色的分账金额
    const getCalculatedAmount = (_role, index) => {
      if (sortedRoleConfigs.value.length === 0) return 0;
      const base = calculationAmount.value;
      let remaining = calculationAmount.value;
      for (let i = 0; i <= index; i++) {
        const currentRole = sortedRoleConfigs.value[i];
        if (i === index) {
          // 到了目标角色，计算并返回
          const result = calculateSingleRole(currentRole, remaining, base);
          return result.amount;
        }
        // 否则计算前面角色的分账并更新剩余金额
        const result = calculateSingleRole(currentRole, remaining, base);
        remaining = result.remaining;
        if (remaining <= 0) return 0;
      }
      return 0;
    };

    // 获取某个角色计算后的剩余金额
    const getRemainingAmount = index => {
      if (sortedRoleConfigs.value.length === 0) return 0;
      const base = calculationAmount.value;
      let remaining = calculationAmount.value;
      for (let i = 0; i <= index; i++) {
        const currentRole = sortedRoleConfigs.value[i];
        const result = calculateSingleRole(currentRole, remaining, base);
        remaining = result.remaining;
      }
      return Math.round(remaining * 100) / 100;
    };

    // 按优先级排序的角色配置（数字越小优先级越高）
    const sortedRoleConfigs = computed(() => {
      return [...form.roleConfigs].sort((a, b) => (a.priority || 0) - (b.priority || 0));
    });

    // 获取计算类型标签
    const getCalculateTypeLabel = type => {
      const t = calculateTypes.find(item => item.value === type);
      return t ? t.label : '-';
    };

    // 计算顺序文本
    const calculationOrderText = computed(() => {
      if (sortedRoleConfigs.value.length === 0) return '请添加角色';
      return sortedRoleConfigs.value.map(r => r.roleName).join(' → ');
    });

    // 格式化分账参数显示
    const formatCommissionParams = role => {
      switch (role.calculateType) {
        case 'RATIO':
          return `${role.value || 0}%${role.minAmount ? `，最低¥${role.minAmount}` : ''}${role.maxAmount ? `，最高¥${role.maxAmount}` : ''}`;
        case 'FIXED':
          return `¥${role.value || 0}`;
        case 'LADDER':
          return `${role.ladderSteps?.length || 0}个阶梯`;
        case 'MINIMUM':
          return `最低¥${role.value || 0}`;
        case 'REMAINDER':
          return '剩余全部分配';
        case 'RELATIVE_REMAINDER':
          return `${role.value || 0}%的剩余金额`;
        default:
          return '-';
      }
    };
    const handleTypeChange = () => {
      form.franchiseeId = null;
      form.productId = null;
    };

    // 打开添加角色表单
    const openAddRoleForm = () => {
      isEditingRole.value = false;
      editingRoleIndex.value = -1;
      resetRoleForm();
      showRoleForm.value = true;
    };

    // 重置角色表单
    const resetRoleForm = () => {
      roleForm.roleCode = '';
      roleForm.roleName = '';
      roleForm.calculateType = 'RATIO';
      roleForm.value = 0;
      roleForm.minAmount = null;
      roleForm.maxAmount = null;
      roleForm.ladderSteps = [];
      roleForm.priority = 0;
    };

    // 关闭角色表单
    const closeRoleForm = () => {
      showRoleForm.value = false;
    };

    // 编辑角色
    const editRole = (role, index) => {
      isEditingRole.value = true;
      editingRoleIndex.value = index;
      Object.assign(roleForm, {
        roleCode: role.roleCode,
        roleName: role.roleName,
        calculateType: role.calculateType || 'RATIO',
        value: role.value || 0,
        minAmount: role.minAmount || null,
        maxAmount: role.maxAmount || null,
        ladderSteps: role.ladderSteps ? [...role.ladderSteps] : [],
        priority: role.priority || 0
      });
      showRoleForm.value = true;
    };

    // 确认角色
    const confirmRole = () => {
      // 验证
      if (!roleForm.roleCode) {
        ElMessage.warning('请选择角色编码');
        return;
      }
      if (!roleForm.roleName.trim()) {
        ElMessage.warning('请输入角色名称');
        return;
      }

      // 根据计算类型验证必填字段
      if (['RATIO', 'FIXED', 'MINIMUM'].includes(roleForm.calculateType) && roleForm.value <= 0) {
        ElMessage.warning('请填写有效的金额或比例');
        return;
      }
      if (roleForm.calculateType === 'LADDER' && roleForm.ladderSteps.length === 0) {
        ElMessage.warning('请至少添加一个阶梯');
        return;
      }

      // 检查角色编码是否已存在（新增时）
      if (!isEditingRole.value) {
        const exists = form.roleConfigs.find(r => r.roleCode === roleForm.roleCode);
        if (exists) {
          ElMessage.warning('该角色编码已存在，不能重复添加');
          return;
        }
      }
      const roleConfig = {
        roleCode: roleForm.roleCode,
        roleName: roleForm.roleName,
        calculateType: roleForm.calculateType,
        value: roleForm.value || undefined,
        minAmount: roleForm.calculateType === 'RATIO' && roleForm.minAmount ? roleForm.minAmount : undefined,
        maxAmount: roleForm.calculateType === 'RATIO' && roleForm.maxAmount ? roleForm.maxAmount : undefined,
        ladderSteps: roleForm.calculateType === 'LADDER' && roleForm.ladderSteps.length > 0 ? roleForm.ladderSteps : undefined,
        priority: roleForm.priority || undefined
      };
      if (isEditingRole.value) {
        form.roleConfigs[editingRoleIndex.value] = roleConfig;
      } else {
        form.roleConfigs.push(roleConfig);
      }
      closeRoleForm();
    };

    // 移除角色
    const removeRole = index => {
      form.roleConfigs.splice(index, 1);
    };

    // 阶梯分成
    const addLadderStep = () => {
      roleForm.ladderSteps.push({
        threshold: 0,
        ratio: 0
      });
    };
    const removeLadderStep = index => {
      roleForm.ladderSteps.splice(index, 1);
    };

    // 保存
    const handleSave = async (enable = false) => {
      try {
        // 验证必填字段
        if (!form.ruleName.trim()) {
          ElMessage.warning('请输入规则名称');
          return;
        }
        if (form.roleConfigs.length === 0) {
          ElMessage.warning('请至少添加一个角色配置');
          return;
        }
        if (form.ruleType === 'FRANCHISEE' && !form.franchiseeId) {
          ElMessage.warning('请选择适用加盟商');
          return;
        }
        if (form.ruleType === 'PRODUCT' && !form.productId) {
          ElMessage.warning('请选择适用产品');
          return;
        }

        // 验证分账金额不超过基准金额
        const base = calculationAmount.value;
        let totalAllocated = 0;
        let remaining = base;
        for (const role of sortedRoleConfigs.value) {
          const result = calculateSingleRole(role, remaining, base);
          totalAllocated += result.amount;
          remaining = result.remaining;
        }

        // 如果分账金额总和超过基准金额，阻止保存
        if (totalAllocated > base + 0.01) {
          // 0.01 容忍度，避免浮点误差
          ElMessage.error(`分账金额总和（¥${formatAmount(totalAllocated)}）超过基准金额（¥${formatAmount(base)}），请调整角色配置`);
          return;
        }

        // 如果有剩余金额，阻止保存
        if (remaining > 0.01) {
          ElMessage.error(`基准金额 ¥${formatAmount(base)} 中有 ¥${formatAmount(remaining)} 未分配给任何角色，请调整分配角色`);
          return;
        }
        const payload = {
          ruleName: form.ruleName,
          ruleType: form.ruleType,
          priority: form.priority,
          status: enable ? 1 : 0,
          referrerTaxReceiverRole: form.referrerTaxReceiverRole || 'PLATFORM',
          remark: form.remark || undefined,
          franchiseeId: form.ruleType === 'FRANCHISEE' ? form.franchiseeId : undefined,
          productId: form.ruleType === 'PRODUCT' ? form.productId : undefined,
          roleConfigs: form.roleConfigs
        };
        if (isEdit.value) {
          await updateCommissionRule(props.editId, payload);
          ElMessage.success('保存成功');
        } else {
          await createCommissionRule(payload);
          ElMessage.success('创建成功');
        }
        emit('success');
        handleClose();
      } catch (error) {
        ElMessage.error(error.message || '保存失败');
      }
    };

    // 关闭弹窗
    const closeModal = () => {
      emit('update:modelValue', false);
    };
    const handleClose = () => {
      closeModal();
    };

    // 加载数据
    const loadData = async () => {
      // 如果是编辑模式，加载规则数据
      if (isEdit.value) {
        try {
          const res = await getCommissionRule(props.editId);
          const rule = res.data || res;
          form.ruleName = rule.ruleName;
          form.ruleType = rule.ruleType;
          form.priority = rule.priority;
          form.franchiseeId = rule.franchiseeId || null;
          form.productId = rule.productId || null;
          form.remark = rule.remark || '';
          form.status = rule.status || 0;
          form.referrerTaxReceiverRole = rule.referrerTaxReceiverRole || 'PLATFORM';
          form.roleConfigs = (rule.roleConfigs || []).map(r => ({
            roleCode: r.roleCode,
            roleName: r.roleName,
            calculateType: r.calculateType || 'RATIO',
            value: r.value || 0,
            minAmount: r.minAmount || null,
            maxAmount: r.maxAmount || null,
            ladderSteps: r.ladderSteps || [],
            priority: r.priority || 0
          }));
        } catch (error) {
          ElMessage.error(error.message || '加载规则数据失败');
        }
      }
    };

    // 监听弹窗显示状态
    watch(() => props.modelValue, val => {
      if (val && !isEdit.value) {
        // 新增模式，重置表单
        form.ruleName = '';
        form.ruleType = 'GLOBAL';
        form.priority = 0;
        form.franchiseeId = null;
        form.productId = null;
        form.remark = '';
        form.status = 0;
        form.referrerTaxReceiverRole = 'PLATFORM';
        form.roleConfigs = [];
        calculationAmount.value = 10000;
      }
      if (val) {
        loadData();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: props.modelValue,
        size: "4xl",
        "panel-class": "max-h-[90vh]",
        scrollable: false,
        onClose: handleClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(isEdit.value ? '编辑分账规则' : '新增分账规则'), 1), _cache[20] || (_cache[20] = _createElementVNode("p", {
          class: "text-sm text-slate-500 mt-0.5"
        }, "配置分账规则", -1))]), _createElementVNode("button", {
          class: "p-1 text-slate-400 hover:text-slate-600",
          onClick: handleClose
        }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[30] || (_cache[30] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900 mb-4 flex items-center gap-2"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        })]), _createTextVNode(" 基础信息 ")], -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[22] || (_cache[22] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("规则名称 ")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.ruleName = $event),
          type: "text",
          placeholder: "请输入规则名称",
          class: "form-input w-full"
        }, null, 512), [[_vModelText, form.ruleName]])]), _createElementVNode("div", null, [_cache[23] || (_cache[23] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("规则类型 ")], -1)), _createVNode(_component_el_select, {
          modelValue: form.ruleType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.ruleType = $event),
          class: "form-select w-full",
          onChange: handleTypeChange
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(ruleTypes, t => {
            return _createVNode(_component_el_option, {
              key: t.value,
              label: t.label,
              value: t.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[24] || (_cache[24] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode(" 优先级 "), _createElementVNode("span", {
          class: "text-slate-400 text-xs font-normal"
        }, "（数值越大优先级越高）")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.priority = $event),
          type: "number",
          min: "0",
          class: "form-input w-full"
        }, null, 512), [[_vModelText, form.priority, void 0, {
          number: true
        }]])]), _createElementVNode("div", _hoisted_8, [_cache[25] || (_cache[25] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "引入人税费归属", -1)), _createVNode(_component_el_select, {
          modelValue: form.referrerTaxReceiverRole,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.referrerTaxReceiverRole = $event),
          class: "form-select w-full"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(taxReceiverOptions, option => {
            return _createVNode(_component_el_option, {
              key: option.value,
              label: option.label,
              value: option.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"]), _cache[26] || (_cache[26] = _createElementVNode("p", {
          class: "mt-1 text-xs text-slate-500"
        }, "引入人税率固定为 6%，税费由所选角色代收。", -1))]), form.ruleType === 'FRANCHISEE' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[27] || (_cache[27] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("适用加盟商 ")], -1)), _createVNode(FranchiseePicker, {
          modelValue: form.franchiseeId,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.franchiseeId = $event),
          placeholder: "选择适用加盟商"
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), form.ruleType === 'PRODUCT' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[28] || (_cache[28] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("适用产品 ")], -1)), _createVNode(ProductPicker, {
          modelValue: form.productId,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.productId = $event),
          placeholder: "选择适用产品"
        }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_cache[29] || (_cache[29] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.remark = $event),
          rows: "2",
          placeholder: "请输入备注信息",
          class: "form-textarea"
        }, null, 512), [[_vModelText, form.remark]])])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
          class: "flex items-center justify-between mb-4"
        }, [_cache[31] || (_cache[31] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900 flex items-center gap-2"
        }, [_createElementVNode("svg", {
          class: "w-5 h-5 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        })]), _createTextVNode(" 角色分账配置 ")], -1)), _createElementVNode("button", {
          class: "btn-primary",
          onClick: openAddRoleForm
        }, "添加角色")]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[33] || (_cache[33] = _createElementVNode("label", {
          class: "text-sm font-medium text-slate-700"
        }, "计算基准金额", -1)), _createElementVNode("div", _hoisted_15, [_cache[32] || (_cache[32] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "¥", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => calculationAmount.value = $event),
          type: "number",
          min: "0",
          class: "form-input w-40"
        }, null, 512), [[_vModelText, calculationAmount.value, void 0, {
          number: true
        }]])]), _cache[34] || (_cache[34] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "根据以上配置实时计算各角色分账金额", -1))])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_cache[37] || (_cache[37] = _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1)), _createElementVNode("span", null, [_cache[35] || (_cache[35] = _createTextVNode("计算顺序：", -1)), _createElementVNode("strong", null, _toDisplayString(calculationOrderText.value), 1), _cache[36] || (_cache[36] = _createTextVNode("（列表顺序即为计算顺序）", -1))])])]), sortedRoleConfigs.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[38] || (_cache[38] = [_createElementVNode("svg", {
          class: "w-12 h-12 mx-auto text-slate-300 mb-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
        })], -1), _createElementVNode("p", null, "暂无角色配置，点击\"添加角色\"开始配置", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedRoleConfigs.value, (role, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: role.roleCode + '_' + index,
            class: "border border-slate-200 rounded-lg p-4 hover:border-primary-300 transition-colors"
          }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(index + 1), 1)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", null, [_cache[39] || (_cache[39] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "角色", -1)), _createElementVNode("div", _hoisted_24, _toDisplayString(role.roleName), 1)]), _createElementVNode("div", null, [_cache[40] || (_cache[40] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "分账方式", -1)), _createElementVNode("div", _hoisted_25, _toDisplayString(getCalculateTypeLabel(role.calculateType)), 1)]), _createElementVNode("div", null, [_cache[41] || (_cache[41] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "分账参数", -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(formatCommissionParams(role)), 1)]), _createElementVNode("div", null, [_cache[42] || (_cache[42] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "优先级", -1)), _createElementVNode("div", _hoisted_27, _toDisplayString(role.priority || 0), 1)]), _createElementVNode("div", null, [_cache[43] || (_cache[43] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "计算金额", -1)), _createElementVNode("div", {
            class: _normalizeClass(["text-sm font-medium", getCalculatedAmount(role, index) > 0 ? 'text-green-600' : 'text-slate-400'])
          }, " ¥" + _toDisplayString(formatAmount(getCalculatedAmount(role, index))), 3), getRemainingAmount(index) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_28, " 剩余: ¥" + _toDisplayString(formatAmount(getRemainingAmount(index))), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑",
            onClick: $event => editRole(role, index)
          }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_30), _createElementVNode("button", {
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => removeRole(index)
          }, [...(_cache[45] || (_cache[45] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_31)])])]);
        }), 128))])])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("button", {
          class: "btn-secondary",
          onClick: handleClose
        }, "取消"), _createElementVNode("button", {
          class: "btn-secondary",
          onClick: _cache[8] || (_cache[8] = $event => handleSave(false))
        }, "保存"), _createElementVNode("button", {
          class: "btn-primary",
          onClick: _cache[9] || (_cache[9] = $event => handleSave(true))
        }, "保存并启用")])]),
        _: 1
      }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: showRoleForm.value,
        size: "2xl",
        "panel-class": "max-h-[90vh]",
        "z-index": 60,
        scrollable: false,
        onClose: closeRoleForm
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createElementVNode("h3", _hoisted_34, _toDisplayString(isEditingRole.value ? '编辑角色' : '添加角色'), 1), _createElementVNode("button", {
          class: "p-1 text-slate-400 hover:text-slate-600",
          onClick: closeRoleForm
        }, [...(_cache[46] || (_cache[46] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_cache[49] || (_cache[49] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "角色信息", -1)), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", null, [_cache[47] || (_cache[47] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("角色编码 ")], -1)), _createVNode(_component_el_select, {
          modelValue: roleForm.roleCode,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => roleForm.roleCode = $event),
          disabled: isEditingRole.value,
          class: "form-select w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "请选择角色",
            value: ""
          }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(roleOptions, r => {
            return _createVNode(_component_el_option, {
              key: r.value,
              label: r.label,
              value: r.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue", "disabled"])]), _createElementVNode("div", null, [_cache[48] || (_cache[48] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("角色名称 ")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => roleForm.roleName = $event),
          type: "text",
          placeholder: "如：推荐人",
          class: "form-input w-full"
        }, null, 512), [[_vModelText, roleForm.roleName]])])])]), _createElementVNode("div", _hoisted_39, [_cache[69] || (_cache[69] = _createElementVNode("h4", {
          class: "text-sm font-medium text-slate-700 mb-3"
        }, "分账配置", -1)), _createElementVNode("div", _hoisted_40, [_cache[50] || (_cache[50] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("分账方式 ")], -1)), _createElementVNode("div", _hoisted_41, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(calculateTypes, type => {
          return _createElementVNode("label", {
            key: type.value,
            class: _normalizeClass(["flex items-center gap-2 p-3 border border-slate-200 rounded-lg cursor-pointer hover:bg-slate-100 transition-colors", {
              'bg-primary-50 border-primary-300': roleForm.calculateType === type.value
            }])
          }, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => roleForm.calculateType = $event),
            value: type.value,
            type: "radio",
            class: "text-primary-600 focus:ring-primary-500"
          }, null, 8, _hoisted_42), [[_vModelRadio, roleForm.calculateType]]), _createElementVNode("span", _hoisted_43, _toDisplayString(type.label), 1)], 2);
        }), 64))])]), roleForm.calculateType === 'RATIO' ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("div", null, [_cache[52] || (_cache[52] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("固定分成比例 ")], -1)), _createElementVNode("div", _hoisted_45, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => roleForm.value = $event),
          type: "number",
          min: "0",
          max: "100",
          step: "0.1",
          class: "form-input flex-1"
        }, null, 512), [[_vModelText, roleForm.value, void 0, {
          number: true
        }]]), _cache[51] || (_cache[51] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "%", -1))])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", null, [_cache[54] || (_cache[54] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "最低金额（可选）", -1)), _createElementVNode("div", _hoisted_47, [_cache[53] || (_cache[53] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "¥", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => roleForm.minAmount = $event),
          type: "number",
          min: "0",
          class: "form-input flex-1"
        }, null, 512), [[_vModelText, roleForm.minAmount, void 0, {
          number: true
        }]])])]), _createElementVNode("div", null, [_cache[56] || (_cache[56] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "最高金额（可选）", -1)), _createElementVNode("div", _hoisted_48, [_cache[55] || (_cache[55] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "¥", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => roleForm.maxAmount = $event),
          type: "number",
          min: "0",
          class: "form-input flex-1"
        }, null, 512), [[_vModelText, roleForm.maxAmount, void 0, {
          number: true
        }]])])])])])) : _createCommentVNode("", true), roleForm.calculateType === 'FIXED' ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_cache[58] || (_cache[58] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("固定金额 ")], -1)), _createElementVNode("div", _hoisted_50, [_cache[57] || (_cache[57] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "¥", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => roleForm.value = $event),
          type: "number",
          min: "0",
          class: "form-input flex-1"
        }, null, 512), [[_vModelText, roleForm.value, void 0, {
          number: true
        }]])])])) : _createCommentVNode("", true), roleForm.calculateType === 'LADDER' ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_cache[60] || (_cache[60] = _createElementVNode("div", {
          class: "text-sm text-slate-600"
        }, "配置阶梯：达到门槛金额后按对应比例分成", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleForm.ladderSteps, (step, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex items-center gap-2"
          }, [_createElementVNode("div", _hoisted_52, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => step.threshold = $event,
            type: "number",
            min: "0",
            placeholder: "门槛金额",
            class: "form-input w-full"
          }, null, 8, _hoisted_53), [[_vModelText, step.threshold, void 0, {
            number: true
          }]])]), _createElementVNode("div", _hoisted_54, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": $event => step.ratio = $event,
            type: "number",
            min: "0",
            max: "100",
            step: "0.1",
            placeholder: "比例%",
            class: "form-input w-full"
          }, null, 8, _hoisted_55), [[_vModelText, step.ratio, void 0, {
            number: true
          }]])]), _createElementVNode("button", {
            class: "p-1.5 text-red-600 hover:bg-red-50 rounded",
            onClick: $event => removeLadderStep(index)
          }, [...(_cache[59] || (_cache[59] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_56)]);
        }), 128)), _createElementVNode("button", {
          class: "w-full py-2 border border-dashed border-slate-300 text-slate-600 rounded-lg text-sm hover:bg-slate-50",
          onClick: addLadderStep
        }, "+ 添加阶梯")])) : _createCommentVNode("", true), roleForm.calculateType === 'MINIMUM' ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_cache[62] || (_cache[62] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-500"
        }, "*"), _createTextVNode("最低金额 ")], -1)), _createElementVNode("div", _hoisted_58, [_cache[61] || (_cache[61] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "¥", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => roleForm.value = $event),
          type: "number",
          min: "0",
          class: "form-input flex-1"
        }, null, 512), [[_vModelText, roleForm.value, void 0, {
          number: true
        }]])]), _cache[63] || (_cache[63] = _createElementVNode("p", {
          class: "text-xs text-slate-400 mt-1"
        }, "当订单金额低于此值时，按此固定金额分成", -1))])) : _createCommentVNode("", true), roleForm.calculateType === 'REMAINDER' ? (_openBlock(), _createElementBlock("div", _hoisted_59, " 该角色将获得所有前置角色分配后的剩余金额 ")) : _createCommentVNode("", true), roleForm.calculateType === 'RELATIVE_REMAINDER' ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_cache[65] || (_cache[65] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createElementVNode("span", {
          class: "text-red-5"
        }, "*"), _createTextVNode("分配比例 ")], -1)), _createElementVNode("div", _hoisted_61, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => roleForm.value = $event),
          type: "number",
          min: "0",
          max: "100",
          step: "0.1",
          class: "form-input flex-1"
        }, null, 512), [[_vModelText, roleForm.value, void 0, {
          number: true
        }]]), _cache[64] || (_cache[64] = _createElementVNode("span", {
          class: "text-slate-500"
        }, "%", -1))]), _cache[66] || (_cache[66] = _createElementVNode("p", {
          class: "text-xs text-slate-400 mt-1"
        }, "该角色将获得剩余金额的指定百分比", -1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_62, [_cache[67] || (_cache[67] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "角色优先级", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => roleForm.priority = $event),
          type: "number",
          min: "0",
          class: "form-input w-full"
        }, null, 512), [[_vModelText, roleForm.priority, void 0, {
          number: true
        }]]), _cache[68] || (_cache[68] = _createElementVNode("p", {
          class: "text-xs text-slate-400 mt-1"
        }, "数字越小优先级越高（用于角色计算顺序排序）", -1))])])])]), _createElementVNode("div", {
          class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
        }, [_createElementVNode("button", {
          class: "btn-secondary",
          onClick: closeRoleForm
        }, "取消"), _createElementVNode("button", {
          class: "btn-primary",
          onClick: confirmRole
        }, "确定")])]),
        _: 1
      }, 8, ["visible"])]))], 64);
    };
  }
};